export const STEP_FIELDS = [
  ['email', 'firstName', 'lastName', 'password', 'confirmPassword'],
  ['businessName', 'tradingName', 'registrationNumber'],
  ['name', 'currency'],
  ['termsAgreement'],
];

export const STEP_SECTIONS = ['account', 'organisation', 'plan', null];

export const ONBOARDING_STEPS = [
  {
    title: 'Step 1: Your Account Details',
    shortTitle: 'Your details',
    subtitle: 'Set up your login and personal information',
    icon: 'user',
    color: '#5bc2e7',
  },
  {
    title: 'Step 2: Create Organisation',
    shortTitle: 'Organisation',
    subtitle: 'Tell us about your business, or add it later',
    icon: 'bank',
    color: '#343579',
  },
  {
    title: 'Step 3: Create Your First Plan',
    shortTitle: 'Plan',
    subtitle: 'Set up your continuity plan, or add it later',
    icon: 'file-text',
    color: '#00685e',
  },
  {
    title: 'Step 4: Activate Your Account',
    shortTitle: 'Activate',
    subtitle: 'The plan is valid for one year from the date you activate it.',
    icon: 'key',
    color: '#f1c400',
  },
];
